import "./ComprehensivePrograms.module.css";
import Navigation from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import PickYourPath from "./sections/PickYourPath";
import InNumbers from "./sections/InNumbers";
import EducationalBenefits from "./sections/EducationalBenefits";
import SupportUs from "./sections/SupportUs";
import SiteFooter from "@/reusable_sections/Footer";
export default function ComprehensiveProgramsPage() {
  return <div>
      <Navigation />
      <Hero />
      <PickYourPath />
      <InNumbers />
      <EducationalBenefits />
      <SupportUs />
      <SiteFooter />
    </div>;
}